import { Major } from './../builders/major_builder';
import { IQuery, IDefineCommand, IQueryMediator, ICommand } from 'core-ts-types';
import { ITransferMajorsDatasource } from '../datasources/transfer_majors_datasource';

angular
  .module('capability-ng-transfer')
  .factory(
    'loadTransferSuggestedMajorsCommand',
    (
      defineCommand: IDefineCommand,
      $http: ng.IHttpService,
      QueryMediator: IQueryMediator,
      ngTransferMajorsDatasource: ITransferMajorsDatasource
    ): ICommand => {
      return defineCommand('loadTransferSuggestedMajorsCommand', function(deferred: ng.IDeferred<IQuery[]>): void {
        $http({
          method: 'GET',
          url: `student/suggested-majors`,
          timeout: 100000
        })
          .then((response: ng.IHttpPromiseCallbackArg<any>) => {
            const suggestedMajors: Major[] = response.data.results;

            ngTransferMajorsDatasource.write(suggestedMajors);

            ngTransferMajorsDatasource.rewrite((source: Record<string, Major>): Record<string, Major> => {
              return _.each(source, (major: Major) => {
                major.isSuggested = false;
              });
            });

            _.each(ngTransferMajorsDatasource.cursor(suggestedMajors), (major: Major): void => {
              major.isSuggested = true;
            });

            deferred.resolve(QueryMediator.runQueries(ngTransferMajorsDatasource));
          })
          .catch(deferred.reject);
      });
    }
  );



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/load_transfer_suggested_majors_command.ts